// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2420":"60794715add2e312","8007":"04dfcacabd70cdb6"}[chunkId] + ".js";
};